import { Box, Flex, HStack, Skeleton, VStack } from '@chakra-ui/react';

export const InvoiceDetailLoadingSkeleton = () => (
    <Box w="100%" h="calc(100vh - 100px)">
        <VStack align="stretch" spacing={3} h="100%">
            <Flex justify="space-between" align="center" px={2}>
                <Skeleton h="34px" w="360px" borderRadius="md" />
                <HStack spacing={2}>
                    <Skeleton h="32px" w="64px" borderRadius="md" />
                    <Skeleton h="32px" w="64px" borderRadius="md" />
                    <Skeleton h="32px" w="88px" borderRadius="md" />
                </HStack>
            </Flex>
            <Flex flex="1" overflow="hidden" border="1px solid" borderColor="gray.200" borderRadius="lg" bg="white">
                <Box w="37%" h="100%" borderRight="1px solid" borderColor="gray.200" bg="gray.50">
                    <Box p={3} h="100%">
                        <Skeleton h="100%" w="100%" borderRadius="md" />
                    </Box>
                </Box>
                <Box flex="1" h="100%" p={4}>
                    <VStack align="stretch" spacing={4} h="100%">
                        <Flex justify="space-between" align="center">
                            <Skeleton h="26px" w="220px" borderRadius="md" />
                            <HStack spacing={2}>
                                <Skeleton h="28px" w="80px" borderRadius="md" />
                                <Skeleton h="28px" w="92px" borderRadius="md" />
                            </HStack>
                        </Flex>
                        <Flex gap={3}>
                            <Skeleton h="72px" flex={1} borderRadius="md" />
                            <Skeleton h="72px" flex={1} borderRadius="md" />
                            <Skeleton h="72px" flex={1} borderRadius="md" />
                        </Flex>
                        <Skeleton h="34px" w="100%" borderRadius="md" />
                        <Box border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden" flex="1">
                            <Flex bg="gray.50" px={3} py={2} borderBottom="1px solid" borderColor="gray.200" gap={3}>
                                <Skeleton h="14px" w="28%" borderRadius="md" />
                                <Skeleton h="14px" w="18%" borderRadius="md" />
                                <Skeleton h="14px" w="14%" borderRadius="md" />
                                <Skeleton h="14px" w="14%" borderRadius="md" />
                                <Skeleton h="14px" w="16%" borderRadius="md" />
                            </Flex>
                            <VStack align="stretch" spacing={0}>
                                {Array.from({ length: 8 }).map((_, idx) => (
                                    <Flex
                                        key={idx}
                                        px={3}
                                        py={3}
                                        borderBottom="1px solid"
                                        borderColor="gray.100"
                                        gap={3}
                                    >
                                        <Skeleton h="16px" w="28%" borderRadius="md" />
                                        <Skeleton h="16px" w="18%" borderRadius="md" />
                                        <Skeleton h="16px" w="14%" borderRadius="md" />
                                        <Skeleton h="16px" w="14%" borderRadius="md" />
                                        <Skeleton h="16px" w="16%" borderRadius="md" />
                                    </Flex>
                                ))}
                            </VStack>
                        </Box>
                    </VStack>
                </Box>
            </Flex>
        </VStack>
    </Box>
);
